import React, { useState } from "react";
import "./HomeSearchbar.css";
import { useNavigate } from "react-router-dom";

const HomeSearchbarTop = () => {
  const [keyword, setKeyword] = useState("");
  
  const navigate = useNavigate();
  const handleSearch = () => {
    if (keyword.trim()) {
      navigate(`/search-vehicles?keyword=${encodeURIComponent(keyword)}`);
    }
  };

  
  return (
    <div className="container mt-2">
      <div className="search-bar-container">
        <div className="input-group">
          <span className="input-group-text">Shop all</span>
          <input
            type="text"
            className="form-control"
            placeholder="Search by car name (Toyota, Honda...)"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          <button className="btn btn-search" onClick={handleSearch}>
            🔍
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeSearchbarTop;